import { Component, OnInit } from '@angular/core';
import { Auth, getRedirectResult } from '@angular/fire/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.css']
})
export class AppComponent implements OnInit {
  
  constructor(
    private auth: Auth,
    private router: Router
  ) {}

  ngOnInit() {
    // Captura el resultado del redirect en móvil
    getRedirectResult(this.auth)
      .then((result) => {
        if (result && result.user) {
          // Usuario completó el login con redirect, redirigir a /home
          this.router.navigate(['/home']);
        }
      })
      .catch((error) => {
        console.error('Error al procesar redirect result:', error);
      });
  }
}
